export const sizes = {
  navbarHeight: '5rem', // Used for the new mobile navbar ONLY
  navbarWidth: '4.5rem', // Used for the side main nav ONLY
  sidebarWidth: '12.5rem', // Used for the sidebar subnav ONLY
  sidebarCollapse: '1.25rem', // Used for the collapsed sidebar subnav ONLY

  container: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1440px',
  },

  table: {
    '3xl': '28rem',
    '2xl': '24rem',
    xl: '18rem',
    lg: '14rem',
    md: '10rem',
    sm: '8rem',
    xs: '6rem',
    '2xs': '4rem',
  },
};
